import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { BorderedBlock } from "../../../../../../features/common-attributes/components/bordered-block/bordered-block.component";
import { SelectField } from "../../../../../../features/forms/fields/select-field/select-field.component";
import { getLanguageOptions } from "../../../../../../redux/actions/executionBriefListActions";
import { selectLanguageResults } from "../../../../../../redux/selectors/commonSelectors";

import { CbTemplateControlProps } from "../../../../types/cb-template-control-props/cb-template-control.props";

export const CbTemplateControlLanguage = (props: CbTemplateControlProps) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getLanguageOptions());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const languagesList = useSelector(selectLanguageResults);
  const languagesOptions = languagesList.map((language) => ({
    value: language.id,
    label: language.languageLong,
  }));

  return (
    <BorderedBlock>
      <SelectField
        form={props.form}
        label="Languages"
        multiple
        name="languages"
        options={languagesOptions}
        placeholder="Select Language"
        required
        userPermissions={props.userPermissions}
      />
    </BorderedBlock>
  );
};
